'use strict';

/* Animazione all'hover su tabella taglie */
var sizeGuideDynamicHover = function() {
    var r = 0;
    var c = 0;

    $('.cc-size-guide-standard .cc-content-table .cc-row-head .cc-col').each(function() {
        c++;
        $(this).attr('data-col-id', c);
    });

    $('.cc-size-guide-standard .cc-content-table .cc-row').each(function() {
        r++;
        c = 0;

        $(this).find('.cc-col').each(function() {
            c++;
            $(this).attr('data-col-id', c);
            $(this).attr('data-row-id', r);
        });
    });

    $(document).on('mouseenter', '.cc-desktop .cc-size-guide-standard .cc-content-table .cc-row .cc-col', function (e) {
        var colId = $(this).data('col-id');
        var rowId = $(this).data('row-id');
        $('.cc-size-guide-standard .cc-content-table .cc-row').each(function() {
            $(this).find('.cc-col').removeClass('cc-hover');
            $(this).find('.cc-col').removeClass('cc-active');
            $(this).find('.cc-col').filter(function () {
                return (($(this).data('col-id') && $(this).data('col-id') == colId && $(this).data('row-id') <= rowId) || ($(this).data('row-id') == rowId && $(this).data('col-id') <= colId));
            }).addClass('cc-hover');
            $(this).find('.cc-col').filter(function () {
                return ($(this).data('col-id') && $(this).data('col-id') == colId && $(this).data('row-id') == rowId);
            }).addClass('cc-active');
        });
    });
    $(document).on('mouseleave', '.cc-desktop .cc-size-guide-standard .cc-content-table .cc-row', function (e) {
        $('.cc-size-guide-standard .cc-content-table .cc-row .cc-col').each(function() {
            $(this).removeClass('cc-hover');
            $(this).removeClass('cc-active');
        });
    });
};

$(document).ready(function () {
    $('body').on('click', '.js-size-measure-selector', function (e) {
        e.preventDefault();
        var measureSelected = $(this);
        var tableSelectedId = measureSelected.data('table-id');
        //var img = measureSelected.data('img');
        
        var $parentDiv = $(this).closest('.cc-content-udm');
        $parentDiv.find('.js-size-measure-selector').each(function() {
            var $button = $(this);
            var isPressed = $button.attr('aria-pressed') === 'true';
            $button.attr('aria-pressed', !isPressed);
        });

        var oldSelected = measureSelected.parent('.js-cc-udm').siblings();
        oldSelected.removeClass('cc-active');
        var oldTableID = oldSelected.find('.js-size-measure-selector').data('table-id');
        $('#' + oldTableID).hide();
        measureSelected.parent('.js-cc-udm').addClass('cc-active');

        //$('.cc-img-section').hide();
        //$('.' + img).show();

        $('#' + tableSelectedId).show();
    });

    $('body').on('click', '.js-change-status', function (e) {
        const button = $(this);
        // Get the current value of aria-expanded
        const currentValue = button.attr('aria-expanded');

        // Toggle the value (true to false, and vice versa)
        const newValue = currentValue === 'true' ? 'false' : 'true';

        // Set the new value for aria-expanded
        button.attr('aria-expanded', newValue);
    });
    

    $('body').on('click', '.js-size-row', function (e) {
        e.preventDefault();
        $('.js-size-row').removeClass('cc-active');
        $(this).addClass('cc-active');
    });

    $('body').on('click', '.js-sizeguide-nav', function (e) {
        e.preventDefault();
        var target = $(this).attr('aria-controls');
        $('.js-sizeguide-content').removeClass('show');
        $('.js-sizeguide-content').removeClass('active');
        $('#' + target).addClass('show');
        $('#' + target).addClass('active');
        $("#"+ target+" button:first").focus(); // Accessibility - Moving focs on first focussable element
    });

    sizeGuideDynamicHover();
});
